import { FatalError } from '@rehaje/errors'

import type { Locales } from '@rehaje/errors'

export class FatalCrossStoreError extends FatalError {
  static override locales: Locales = {
    'en-US': 'Forbidden cross-store insertion of %s node',
    'zh-CN': '禁止跨 Store 插入 %s 节点',
    'zh-HK': '禁止跨 Store 插入 %s 节點'
  }

  override name = 'FatalCrossStoreError' as const

  constructor(type: string) {
    super(type)
  }
}

export class FatalSelfInsertError extends FatalError {
  static override locales: Locales = {
    'en-US': 'Forbidden self-insertion of %s node',
    'zh-CN': '禁止自插入 %s 节点',
    'zh-HK': '禁止自插入 %s 节點'
  }

  override name = 'FatalSelfInsertError' as const

  constructor(type: string) {
    super(type)
  }
}
